import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";
import Swarm from "../actors/swarm";
import { goToScene } from "../main";
import Bill from "../actors/characters/bill";
import FarmerJackson from "../actors/characters/farmerJackson";
import { createNotification } from "../utils";

export class Crossroads extends ex.Scene {
  constructor() {
    super();
    const player = new Player(19 * 16, 3 * 16);
    // this.backgroundColor = ex.Color.fromHex("#010101");
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 3;
    this.interacting = null;
    this.jackson = new FarmerJackson({ x: 1 * 16, y: 13 * 16 }, "crossroads");
  }
  onInitialize(engine) {
    Resources.CrossroadsMap.addToScene(this);

    console.log("wood from crossroads: ", this.wood);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.jackson);
    this.player.wearingVeil = false;
    // this.player = Resources.HouseMap.getObjectsByName("player");
    this.camera.zoom = 1;

    // this.camera.strategy.lockToActor(this.player);
    this.door = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 0 * 16),
      width: 45,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        console.log("TRIGGERED: Go TO SCENE");
        goToScene("home", { x: 22 * 16, y: 20 * 16 });
      },
    });
    this.townDoor = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 20 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 29 * 16, y: 3 * 16 });
      },
    });
    this.add(this.townDoor);
    this.add(this.door);
    this.jacksonsDoor = new ex.Trigger({
      pos: new ex.Vector(6 * 16, 11 * 16 + 8),
      width: 32,
      height: 40,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("jacksonsHouse", { x: 20 * 16, y: 17 * 16 });
      },
    });
    this.add(this.jacksonsDoor);
    this.billsDoor = new ex.Trigger({
      pos: new ex.Vector(32 * 16, 9 * 16 + 8),
      width: 32,
      height: 40,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("billsHouse", { x: 20 * 16, y: 18 * 16 });
      },
    });
    this.add(this.billsDoor);
    this.player.on("collisionstart", (e) => {
      console.log("collided: ", e);
      this.interacting = e.other.owner.name;
      if (this.interacting == "jackson") {
        createNotification("Space: Interact").create();
      }
    });
    this.player.on("collisionend", (e) => {
      this.interacting = null;
      createNotification().destroy();
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
      this.player.lastDir = data.data.direction;
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.interacting !== null && this.interacting == "jackson") {
        this.jackson.startInteraction(this.player.lastDir, this.player);
      }
    }
  }
}
